// extracted by mini-css-extract-plugin
export default {"errorPage":"styles_errorPage__Z455a","buttons":"styles_buttons__ghm1Q","fullView":"styles_fullView__uD-ut","shimmer":"styles_shimmer__06olr"};